import React from 'react';
import { SpinradProvider, useSpinradContext } from './context/SpinradContext';
import { GlobalStyles } from './globalStyles';
import Header from './header';
import { MainArea, PageRoot } from './styles';
import CardModal from './modals/cardModal';
import ConfirmDialog from './modals/confirmDialog';
import Toast from './modals/toast';
import TodoCreateModal from './modals/todoCreateModal';
import OverviewView from './overviewView';
import TodoListView from './todoListView';
import WorkboardView from './workboardView';
import { useAuth } from '../../context/authContext';
import { getSpinradWidgets } from '../../utils/fixedWidgets';
import { defaultCoreValues } from './data';

const SpinradPage: React.FC = () => {
  const { currentView } = useSpinradContext();

  return (
    <PageRoot>
      <Header />
      <MainArea>
        <OverviewView active={currentView === 'ov'} />
        <WorkboardView active={currentView === 'wb'} />
        <TodoListView active={currentView === 'todo'} />
      </MainArea>

      <CardModal />
      <ConfirmDialog />
      <TodoCreateModal />
      <Toast />
    </PageRoot>
  );
};

const Spinrad2: React.FC = () => {
  const { user } = useAuth();

  const urlParams = new URLSearchParams(window.location.search);
  const selectedId = Number(urlParams.get('id')) || undefined;

  const spinradWidgets = getSpinradWidgets(
    user?.selectedUsergroup?.settings?.widgets?.children ?? [],
    selectedId,
  );

  const coreValues = spinradWidgets[0]?.spinradValues?.length
    ? spinradWidgets[0].spinradValues
    : defaultCoreValues;

  return (
    <SpinradProvider
      coreValues={coreValues}
      usergroupId={user?.selectedUsergroup?.userGroupId}
    >
      <GlobalStyles />
      <SpinradPage />
    </SpinradProvider>
  );
};

export default Spinrad2;
